import './App.css';
import HomePage from './Pages/HomePage/HomePage';
import "swiper/css/bundle";

function App() {
  return (
    <div className="App">
        <HomePage />
    </div>
  );
}

export default App;
